var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SocketService } from '@app/core/socket.service';
import { ReplyAbstractComponent } from '@app/shared/components/reply/reply-abstract.component';
import { ChartComponent } from 'angular2-chartjs';
import { BalanceHistoryService } from '@app/core/account/balance-history.service';
var MersenneTwister = require('mersennetwister');
var ReplyCrashComponent = /** @class */ (function (_super) {
    __extends(ReplyCrashComponent, _super);
    function ReplyCrashComponent(socket, balanceHistory) {
        var _this = _super.call(this, socket, balanceHistory) || this;
        _this.socket = socket;
        _this.balanceHistory = balanceHistory;
        _this.data = null;
        _this.chartData = {
            labels: [],
            datasets: [
                {
                    data: [],
                    label: 'Player',
                    backgroundColor: 'rgba(225,225,225,0)',
                    borderColor: 'rgba(99, 190, 255, 1)',
                    pointBackgroundColor: 'rgba(148,159,177,1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(148,159,177,0.8)',
                    borderWidth: 5,
                    pointRadius: 0,
                    lineTension: 1,
                },
                {
                    data: [],
                    label: 'Chart',
                    backgroundColor: 'rgba(225,225,225,0)',
                    borderColor: 'rgba(148,159,177,1)',
                    pointBackgroundColor: 'rgba(148,159,177,1)',
                    pointBorderColor: '#fff',
                    pointHoverBackgroundColor: '#fff',
                    pointHoverBorderColor: 'rgba(148,159,177,0.8)',
                    borderWidth: 5,
                    pointRadius: 0,
                    lineTension: 1,
                },
            ],
        };
        _this.options = {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false,
                labels: { fontColor: 'grey' },
            },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            fontColor: 'white',
                            maxRotation: 0,
                            maxTicksLimit: 1,
                            callback: function (label, index, labels) {
                                return Number(label).toFixed(1) + 's';
                            },
                        },
                        gridLines: {
                            color: 'hsla(0, 0%, 85%, .1)',
                        },
                    },
                ],
                yAxes: [
                    {
                        ticks: {
                            fontColor: 'white',
                            maxRotation: 0,
                            min: 1,
                            max: 1.5,
                            maxTicksLimit: 4,
                            callback: function (label, index, labels) {
                                return Number(label).toFixed(1) + 'x';
                            },
                        },
                        gridLines: {
                            color: 'hsla(0, 0%, 85%, .1)',
                        },
                    },
                ],
            },
            layout: {
                height: '100%',
            },
            elements: {
                line: {
                    tension: 0,
                },
            },
            animation: {
                duration: 1,
            },
        };
        return _this;
    }
    ReplyCrashComponent.prototype.ngAfterViewInit = function () {
        // this.component.chart.canvas.height = '100%';
        // this.component.chart.update();
    };
    ReplyCrashComponent.prototype.initialize = function (data) {
        if (data.game !== 'crash') {
            this._error = true;
            return;
        }
        this.data = data;
        this.drawChart(data.multiplayer.number, data.multiplayer.multiplier, 1);
        if (data.win !== undefined) {
            if (!data.win) {
                this.chartData.datasets[0].borderColor = 'rgba(248, 93, 93, 1)';
            }
            this.drawChart(0, data.cashout, 0);
        }
        this._loading = false;
        this._error = false;
    };
    ReplyCrashComponent.prototype.generateGame = function () {
        var data = {
            game: 'crash',
            multiplayer: {
                multiplier: null,
                number: this.generateLuckyNr(this.serverSeed, this.playerSeed),
            },
        };
        data.multiplayer.multiplier = this.formula(data.multiplayer.number);
        this.initialize(data);
    };
    ReplyCrashComponent.prototype.drawChart = function (randomNr, multiplier, chartType) {
        if (chartType) {
            this.chartData.labels = [];
            this.chartData.datasets[0].borderColor = 'rgba(99, 190, 255, 1)';
            this.chartData.datasets[0].data = [];
            this.chartData.datasets[1].data = [];
            this.options.scales.yAxes[0].ticks.max = 1.5;
            if (multiplier > 1.5) {
                this.options.scales.yAxes[0].ticks.max = multiplier;
            }
            this.options = Object.assign({}, this.options);
            for (var i = 0; i < randomNr; i++) {
                if (chartType) {
                    this.chartData.labels.push(i / 20);
                }
                this.chartData.datasets[chartType].data.push(this.formula(i));
            }
        }
        else {
            var i = 0;
            while (multiplier > this.formula(i)) {
                this.chartData.datasets[chartType].data.push(this.formula(i));
                i++;
            }
        }
        this.chartData = Object.assign({}, this.chartData);
    };
    ReplyCrashComponent.prototype.formula = function (x, max) {
        if (max === void 0) { max = 500; }
        return -(max / (x - max));
    };
    ReplyCrashComponent.prototype.generateLuckyNr = function (serverSeed, clientSeed) {
        if (!serverSeed || !clientSeed) {
            return null;
        }
        clientSeed = clientSeed.replace('0x', '');
        serverSeed = serverSeed.replace('0x', '');
        var clSeedSplitted = clientSeed.match(/.{1,6}/g);
        var srvSeedSplitted = serverSeed.match(/.{1,6}/g);
        var seedsCombined = clSeedSplitted.concat(srvSeedSplitted);
        var seedsCominedNum = [];
        for (var i = 0; i < seedsCombined.length; i++) {
            seedsCominedNum[i] = parseInt(seedsCombined[i], 16);
        }
        var mt = new MersenneTwister();
        mt.seedArray(seedsCominedNum);
        return mt.int() % 500;
    };
    return ReplyCrashComponent;
}(ReplyAbstractComponent));
export { ReplyCrashComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/reply/reply-crash.component.ts.pre-build-optimizer.js